import type { JSX } from 'react';
import { Skeleton } from '@/components/feedback';

export interface PublicUnitGroupListSkeletonProps {
  groups?: number;
  unitsPerGroup?: number;
}

export function PublicUnitGroupListSkeleton({
  groups = 2,
  unitsPerGroup = 3,
}: PublicUnitGroupListSkeletonProps): JSX.Element {
  const totalUnits = groups * unitsPerGroup;

  return (
    <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-3">
      {Array.from({ length: totalUnits }).map((_, unitIndex) => (
        <div
          key={unitIndex}
          className="flex flex-col gap-3 rounded-2xl border border-surface-subtle bg-white p-4 shadow-sm"
        >
          <Skeleton className="h-36 w-full rounded-xl bg-surface-subtle" />
          <Skeleton className="h-4 w-40 rounded-full bg-surface-subtle" />
          <Skeleton className="h-3 w-32 rounded-full bg-surface-subtle" />
          <Skeleton className="h-3 w-24 rounded-full bg-surface-subtle" />
        </div>
      ))}
    </div>
  );
}
